<template>
  <div>
    <common-sur-header/>
    <common-header
        :nav-items="header.navItems"
        :cta-buttons="header.ctaButtons"
    />
    <general-header text="Contact" :icon-url="require('../../img/valet.png')"/>
    <div class="contact-info-container">
      <div class="contact-info-container-bloc">
        <h2 class="isidorasansalt-bold-magic-potion-28px">Adresse de Pop Valet :</h2>
        <p class="isidorasansalt-semi-bold-magic-potion-18px">36, rue Scheffer - 75116 Paris</p>
      </div>
    </div>
    <common-footer :is-maif="isMaif"></common-footer>
  </div>
</template>

<script>
import GeneralHeader from "@/components/GeneralHeader";
import CommonHeader from "@/components/common/CommonHeader";
import CommonSurHeader from "@/components/common/CommonSurHeader";
import CommonFooter from "@/components/common/CommonFooter";

export default {
  name: "GeneralContact",
  components: {
    GeneralHeader,
    CommonHeader,
    CommonSurHeader,
    CommonFooter,
  },
  props: [
    'header',
    'isMaif'
  ],
}
</script>

<style scoped>
.contact-info-container-bloc {
  text-align: center;
  line-height: 29px;
}
.contact-info-container {
  display: flex;
  justify-content: space-around;
  padding: 100px 150px;
}

@media screen and (max-width: 991px) {
  .contact-info-container-bloc {
   margin: 50px 0;
  }
  .contact-info-container {
    flex-direction: column;
    padding: 50px 100px;
  }
}
</style>